/* eslint-disable */

import { post, get } from '../../../helpers/http-request';

const GetTickerData = () => post('functions/tickerData');

const GetIndicesData = (reqObj) => post('functions/getIndices', JSON.stringify(reqObj));

const getTopGainersLoosersData = (reqObj) =>
  post('functions/getTopGainersLoosers', JSON.stringify(reqObj));

const getAdvanceDeclinesData = (reqObj) =>
  post('functions/getAdvanceDeclines', JSON.stringify(reqObj));

const getStockList = () => get('functions/getStockList');

// export const getStoriesByTag = tag =>
//   fetch(`${getStaticConfig(['publisher', 'sketches_host'])}/api/v1/stories?tag=${tag}`);

const fetchWithNoIndex = (url) => {
  return fetch(url, {
    headers: {
      'X-Robots-Tag': 'noindex',
    },
  });
};

export const IndianIndices = ({ duration = '1D' }) => {
  return fetchWithNoIndex(
    `https://bloombergquint-beta.quintype.io/feapi/markets/indices/indian-indices?duration=${duration}`
  );
};

const GlobalMarkets = ({ tab = 'currency', sort = false }) => {
  return fetchWithNoIndex(
    `https://bloombergquint-beta.quintype.io/feapi/markets/indices/global-markets?tab=${tab}&sort=${sort}`
  );
};

const IndicesDetail = ({ id, duration = '1D' }) => {
  return fetchWithNoIndex(
    `https://bloombergquint-beta.quintype.io/feapi/markets/indices/${id}/details?duration=${duration}`
  );
};

export const AdvancesDeclines = () => {
  return fetchWithNoIndex(`/feapi/markets/advances-declines`);
};

const StockStats = ({ type, filter_key, filter_value, duration }) => {
  return fetchWithNoIndex(
    `https://bloombergquint-beta.quintype.io/feapi/markets/indices/stock-stats?type=${type}&filter_key=${filter_key}&filter_value=${filter_value}&duration=${duration}`
  );
};

const StockDetail = () => {
  return fetch(
    'http://localhost:8080/app/isomorphic/components/pages/markets/json/stock-movement.json'
  );
};

const StockKeyStatistics = () => {
  return fetch(
    'http://localhost:8080/app/isomorphic/components/pages/markets/json/stock-key-statistics.json'
  );
};
const StockMovingAverages = () => {
  return fetch(
    'http://localhost:8080/app/isomorphic/components/pages/markets/json/stock-moving-averages.json'
  );
};
const StockBasicDetails = () => {
  return fetch(
    'http://localhost:8080/app/isomorphic/components/pages/markets/json/stock-basic-details.json'
  );
};
const StockPriceStats = () => {
  return fetch(
    'http://localhost:8080/app/isomorphic/components/pages/markets/json/stock-price-stats.json'
  );
};

const getCollectionBySlug = (slug = 'trending-markets') => {
  return fetch(`https://bloombergquint-web.qtstage.io/api/v1/collections/${slug}`);
};

const getResearchReports = () => {
  return fetch(`https://bloombergquint-web.qtstage.io/api/v1/collections/research-reports`);
};
